"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translateLegacyColors = exports.hexLighter = exports.hexDarker = void 0;

/* eslint-disable id-length */
var decomposeColor = function decomposeColor(color) {
  return {
    R: parseInt("".concat(color[1]).concat(color[2]), 16),
    G: parseInt("".concat(color[3]).concat(color[4]), 16),
    B: parseInt("".concat(color[5]).concat(color[6]), 16)
  };
};

var hexDarker = function hexDarker(color) {
  var factor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 30;

  if (!color || color === '') {
    return color;
  }

  var base = decomposeColor(color);
  return Object.keys(base).reduce(function (accum, current) {
    var amount = Math.round(base[current] / 100 * factor);
    var decimal = Number(base[current] - amount);
    var hex = decimal.toString(16).padStart(2, '0');
    return accum + hex;
  }, '#');
};

exports.hexDarker = hexDarker;

var hexLighter = function hexLighter(color) {
  var factor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 30;

  if (!color || color === '') {
    return color;
  }

  var base = decomposeColor(color);
  return Object.keys(base).reduce(function (accum, current) {
    var amount = Math.round((255 - base[current]) / 100 * factor);
    var decimal = Number(base[current] + amount);
    var hex = decimal.toString(16).padStart(2, '0');
    return accum + hex;
  }, '#');
};

exports.hexLighter = hexLighter;

var translateLegacyColors = function translateLegacyColors(colors) {
  Object.keys(colors).forEach(function (key) {
    var value = colors[key];

    if (value && value !== '' && value.charAt(0) !== '#') {
      colors[key] = "#".concat(value);
    }
  });
  var base = colors.base,
      buttons = colors.buttons,
      cug = colors.cug,
      links = colors.links,
      text = colors.text;
  return {
    palette: {
      primary: {
        light: hexLighter(buttons, 40),
        base: buttons,
        dark: hexDarker(buttons, 40)
      },
      secondary: {
        light: hexLighter(links, 40),
        base: links,
        dark: hexDarker(links, 40)
      },
      text: {
        lightest: '#ffffff',
        light: hexLighter(text, 40),
        base: text,
        dark: hexDarker(text, 40)
      },
      promoPrimary: {
        light: hexLighter(cug, 40),
        base: cug,
        dark: hexDarker(cug, 40)
      },
      background: {
        lightest: '#ffffff',
        light: hexLighter(base, 40),
        base: base,
        dark: hexDarker(base, 40),
        darkest: hexDarker(base, 80)
      }
    }
  };
};

exports.translateLegacyColors = translateLegacyColors;